
const PermissionEnum = [
    'Users',
    'Roles',
    'Templates',
    'Reports',
    'Clients',
    'Plans',
    'Orders',
    'Logs',
    'PayMethods',
    'ListSsl',
    'InbursaUsers',
    'InbursaProspects',
    'InbursaTemplates',
    'InbursaUsersLogin',
    'MonitorUrls',
];

export default PermissionEnum;